// @ts-nocheck
import React from 'react'

/**
 * Hook to catch errors in the asynchronous code callbacks that go to the ErrorBoundary.
 * */
export function useCustomError() {
	const [customError, setCustomError] = React.useState(null)
	if (customError) {
		throw customError
	}
	return setCustomError
}
